import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  Outlet,
} from "react-router-dom";
import Navbar from "./components/Navbar";
import Home from "./pages/Home";
import WhyEpsilon from "./pages/WhyEpsilon";
import UseCases from "./pages/UseCases";
import Pricing from "./pages/Pricing";
import Team from "./pages/Team";
import Blog from "./pages/Blog";
import Docs from "./pages/Docs";
import AuthPage from "./pages/AuthPage";
import DashboardLayout from "./layouts/DashboardLayout";
import KnowledgeBases from "./layouts/KnowledgeBases";
import CreateChatDialog from "./components/CreateChatDialog";
import ChatInterface from "./components/ChatInterface";
import Chats from "./layouts/Chats";
import Footer from "./components/Footer";
import EditKnowledgeBase from "./components/EditKnowledgeBase";
import { AppProvider } from './contexts/AppContext';

const LayoutWithNavbar = () => (
  <>
    <Navbar />
    <Outlet />
    <Footer />
  </>
);

const PrivateRoute = ({ children }) => {
  const user = JSON.parse(localStorage.getItem('user'));
  return user ? children : <Navigate to="/auth" />;
};

function App() {
  return (
    <AppProvider>
      <Router>
        <Routes>
          {/* Public Routes */}
          <Route element={<LayoutWithNavbar />}>
            <Route path="/" element={<Home />} />
            <Route path="/why-epsilon" element={<WhyEpsilon />} />
            <Route path="/use-cases" element={<UseCases />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/team" element={<Team />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/docs" element={<Docs />} />
          </Route>

          {/* Auth Route */}
          <Route path="/auth" element={<AuthPage />} />

          {/* Protected Routes */}
          <Route path="/dashboard" element={
            <PrivateRoute>
              <DashboardLayout />
            </PrivateRoute>
          }>
            <Route path="chats">
              <Route index element={<Chats />} />
              <Route path="create" element={<CreateChatDialog />} />
              <Route path=":chatId" element={<ChatInterface />} />
            </Route>
            <Route path="knowledge" element={<KnowledgeBases />} />
            <Route path="knowledge/edit/:id" element={<EditKnowledgeBase />} />
            <Route index element={<Navigate to="knowledge" replace />} />
          </Route>

          {/* Redirect to Home for unknown routes */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
    </AppProvider>
  );
}

export default App;